import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition';
import type { IImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition/interface';
import { useMutation } from '@tanstack/react-query';

const repository = new ImportTableDefinitionRepository();

export const _checkRevisionCompatibility = () => {
  return useMutation({
    mutationFn: async (params: IImportTableDefinitionRepository.CheckRevisionCompatibility.Params) => {
      return repository.checkRevisionCompatibility(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    ...UseMutationDefaultOptions,
  });
};
